(() => {
  const menus = document.querySelectorAll('[data-qgc-account]');
  menus.forEach(menu => {
    const close = () => { menu.open = false; };
    menu.querySelector('[data-qgc-account-close]').addEventListener('click', () => {
      close(); menu.querySelector('summary').focus();
    });
    document.addEventListener('click', event => { if (!menu.contains(event.target)) close(); });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); menu.querySelector('summary').focus(); }
    });
    menu.addEventListener('toggle', () => {
      if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
    });
  });
})();
